module.exports = __webpack_public_path__ + "static/media/live04_05_2018.3ddf49e4.jpg";